import React, { FC, Fragment } from 'react';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';
import EditIcon from '../../../../components/icon/EditIcon';
import ShareIcon from '../../../../components/icon/ShareIcon';
import PreviewIcon from '../../../../components/icon/PreviewIcon';
import GearIcon from '../../../../components/icon/GearIcon';
import TrashIcon from '../../../../components/icon/TrashIcon';

export enum ActionType {
    EDIT,
    SHARE,
    PREVIEW,
    SETTING,
    DELETE,
}
interface SiteActionModalProps extends DialogProps {
    onActionClick: (action: ActionType) => void;
}

const ActionModal: FC<SiteActionModalProps> = ({ onActionClick, ...props }) => {
    return (
        <Fragment>
            <Dialog anchor="bottom" {...props} showClose>
                <div className={`mt-10 px-28 pb-40`}>
                    <div
                        className="flex items-center justify-start py-12 cursor-pointer hover:bg-primary-10"
                        onClick={() => {
                            onActionClick(ActionType.EDIT);
                        }}
                    >
                        <div className="text-20 h-28 w-28 flex items-center justify-center">
                            <EditIcon />
                        </div>
                        <p className="text-18 ml-8">Edit</p>
                    </div>
                    <div
                        className="flex items-center justify-start py-12 cursor-pointer hover:bg-primary-10"
                        onClick={() => {
                            onActionClick(ActionType.SHARE);
                        }}
                    >
                        <div className="text-20 h-28 w-28 flex items-center justify-center">
                            <ShareIcon />
                        </div>
                        <p className="text-18 ml-8">Share</p>
                    </div>
                    <div
                        className="flex items-center justify-start py-12 cursor-pointer hover:bg-primary-10"
                        onClick={() => {
                            onActionClick(ActionType.PREVIEW);
                        }}
                    >
                        <div className="text-20 h-28 w-28 flex items-center justify-center">
                            <PreviewIcon />
                        </div>
                        <p className="text-18 ml-8">Preview</p>
                    </div>
                    <div
                        className="flex items-center justify-start py-12 cursor-pointer hover:bg-primary-10"
                        onClick={() => {
                            onActionClick(ActionType.SETTING);
                        }}
                    >
                        <div className="text-20 h-28 w-28 flex items-center justify-center">
                            <GearIcon />
                        </div>
                        <p className="text-18 ml-8">Settings</p>
                    </div>
                    <div
                        className="flex items-center justify-start text-error py-12 cursor-pointer hover:bg-primary-10"
                        onClick={() => {
                            onActionClick(ActionType.DELETE);
                        }}
                    >
                        <div className="text-20 h-28 w-28 flex items-center justify-center">
                            <TrashIcon />
                        </div>
                        <p className="text-18 ml-8">Delete</p>
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
};

export default ActionModal;
